import { useEffect } from 'react';

const reportWebVitals = (metric) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", metric.name, {
      value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
      event_category: "Web Vitals",
      event_label: metric.id,
      non_interaction: true,
    });
  }
};

export const useWebVitals = () => {
  useEffect(() => {
    const loadWebVitals = async () => {
      try {
        const { onCLS, onFID, onFCP, onLCP, onTTFB } = await import("web-vitals");
        onCLS(reportWebVitals);
        onFID(reportWebVitals);
        onFCP(reportWebVitals);
        onLCP(reportWebVitals);
        onTTFB(reportWebVitals);
      } catch (error) {
        console.error("Error initializing web-vitals:", error);
      }
    };

    if (typeof window !== "undefined") {
      loadWebVitals();
    }
  }, []);

  return null;
};

export const PerformanceOptimizer = ({ children }) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const links = document.querySelectorAll("link[rel=\"stylesheet\"]");
    links.forEach(link => {
      if (!link.href.includes("critical")) {
        link.media = "print";
        link.onload = () => link.media = "all";
      }
    });

    const optimizeImage = (img) => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.classList.remove("lazy");
      }
    };

    const images = document.querySelectorAll("img[data-src]");
    if ("IntersectionObserver" in window) {
      const imageObserver = new IntersectionObserver(
        (entries) => entries.forEach(entry => {
          if (entry.isIntersecting) {
            optimizeImage(entry.target);
            imageObserver.unobserve(entry.target);
          }
        })
      );

      images.forEach(img => imageObserver.observe(img));
    } else {
      images.forEach(optimizeImage);
    }
  }, []);

  return children;
};
